export default {
    async updateCart(ctx) {
        //const { data } = await getCart()
        ctx.commit('addCart', {
            count: 0
        })
    }
}